import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, from, switchMap, catchError, throwError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

const STOP_CODES_PATH = '/stopcodes';

@Injectable()
export class StopCodesAuthInterceptor implements HttpInterceptor {
  private readonly msal = inject(MsalService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const url = req.url;
    if (!url.includes(STOP_CODES_PATH)) {
      return next.handle(req);
    }
    // MSAL interceptor already covers /dotnet/api/* (and optional absolute base URL).
    // Skip to avoid duplicate token acquisition and request cloning.
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const instance = this.msal.instance;
    const account =
      instance.getActiveAccount() ?? instance.getAllAccounts()?.[0] ?? null;
    if (!account) {
      return next.handle(req);
    }

    const scope = environment.stopCodesScope;

    return from(
      this.msal.acquireTokenSilent({
        account,
        scopes: [scope],
      }),
    ).pipe(
      switchMap((result) => {
        const token = result?.accessToken;
        if (!token) {
          return next.handle(req);
        }
        const cloned = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next.handle(cloned);
      }),
      catchError((err: unknown) => throwError(() => err)),
    );
  }
}
